export const formatTimezone = (data) => {
  if (data === 'SYSTEM_TIME') {
    return 'System time'
  }
  if (data === 'SERVER_TIME') {
    return 'GMT+3'
  }

  return data
}
